import GetAntiForgeryToken from './AntiForgeryToken';

/*
 * Taken from http://stackoverflow.com/questions/1346070/asp-net-mvc-antiforgerytoken-over-ajax/16495855#16495855
*/

/* from http://stackoverflow.com/a/17036953/90609 */
/* see also http://stackoverflow.com/a/16495855/90609 */
$.ajaxPrefilter((options) => {
    const requestType = options.type ?? '';

    if (requestType.toLowerCase() !== 'get') {
        const token = GetAntiForgeryToken();
        if (token) {
            if (!options.data) {
                options.data = "";
            }
            if (options.data.indexOf(token.name) === -1) {
                const tokenQuery = token.name + '=' + token.value;
                options.data = options.data
                    ? (options.data + '&' + tokenQuery)
                    : tokenQuery;
            }
        }
    }
});